var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2586 3.87484L9.30859 1.0165C8.50026 0.549837 7.50026 0.549837 6.68359 1.0165L1.74193 3.87484C0.933593 4.3415 0.433594 5.20817 0.433594 6.14984V11.8498C0.433594 12.7832 0.933593 13.6498 1.74193 14.1248L6.69193 16.9832C7.50026 17.4498 8.50026 17.4498 9.31693 16.9832L14.2669 14.1248C15.0753 13.6582 15.5753 12.7915 15.5753 11.8498V6.14984C15.5669 5.20817 15.0669 4.34984 14.2586 3.87484ZM8.00026 5.1165C9.07526 5.1165 9.94193 5.98317 9.94193 7.05817C9.94193 8.13317 9.07526 8.99984 8.00026 8.99984C6.92526 8.99984 6.05859 8.13317 6.05859 7.05817C6.05859 5.9915 6.92526 5.1165 8.00026 5.1165ZM10.2336 12.8832H5.76693C5.09193 12.8832 4.70026 12.1332 5.07526 11.5748C5.64193 10.7332 6.74193 10.1665 8.00026 10.1665C9.25859 10.1665 10.3586 10.7332 10.9253 11.5748C11.3003 12.1248 10.9003 12.8832 10.2336 12.8832Z",
    fill: "#0044EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser2);
export default __webpack_public_path__ + "static/media/icon_user_2.10f219ccd76674a989a3ebb1bd702829.svg";
export { ForwardRef as ReactComponent };